import { QRCodeSVG } from "qrcode.react"
import { useEffect, useState } from "react"
import { cn } from "@/lib/utils"

export interface QRCodeGeneratorProps {
  value: string
  size?: number
  level?: "L" | "M" | "Q" | "H"
  className?: string
  includeMargin?: boolean
}

export function QRCodeGenerator({
  value,
  size = 256,
  level = "M",
  className,
  includeMargin = true,
}: QRCodeGeneratorProps) {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return (
      <div
        className={cn("flex items-center justify-center bg-slate-100", className)}
        style={{ width: size, height: size }}
      >
        <span className="text-sm text-slate-500" aria-live="polite">
          読み込み中...
        </span>
      </div>
    )
  }

  if (!value) {
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-slate-100 border border-slate-200",
          className
        )}
        style={{ width: size, height: size }}
        role="alert"
      >
        <span className="text-sm text-slate-500">URLが設定されていません</span>
      </div>
    )
  }

  return (
    <div className={cn("inline-block", className)}>
      <QRCodeSVG
        value={value}
        size={size}
        level={level}
        includeMargin={includeMargin}
        aria-label={`QRコード: ${value}`}
      />
    </div>
  )
}
